import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule }   from '@angular/forms';

import { MapService } from './map.service';
import { AppService } from './app.service';
import { GeojsonService } from './geojson.service';

import { AppComponent } from './app.component';
import { MapBoxComponent } from './map-box/map-box.component';
import { SoinuProgressComponent } from './soinu-progress/soinu-progress.component';
import { MessagesComponent } from './messages/messages.component';
import { AddContentComponent } from './add-content/add-content.component';


@NgModule({
  declarations: [
    AppComponent,
    MapBoxComponent,
    SoinuProgressComponent,
    MessagesComponent,
    AddContentComponent
  ],
  imports: [
    BrowserModule,
		HttpClientModule,
    FormsModule
  ],
  providers: [
		MapService,
		AppService,
		GeojsonService,
    { provide: LOCALE_ID, useValue: 'es'},
	],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts